// Cronômetro por etapa dos processamentos de arquivo (Prestamista/SQG/DFI).
// Medido no navegador: a etapa começa a contar quando o polling percebe a mudança de
// status e para quando passa para a próxima (precisão de ~ um intervalo de polling).

export const ETAPAS_CRONOMETRADAS = [
    { chave: "fila", rotulo: "Na fila" },
    { chave: "processando", rotulo: "Processando" },
    { chave: "email", rotulo: "E-mail" },
];

export function etapaDoStatus(status, statusEmail) {
    if (status === "Na Fila") return "fila";
    if (status === "Processando") return "processando";
    if (status === "Concluído" && statusEmail === "Pendente") return "email";
    return null;
}

// Fecha a etapa anterior e abre a nova (etapaNova null = processamento terminou).
export function registrarTransicao(tempos, etapaAnterior, etapaNova, agora) {
    const novos = { ...(tempos || {}) };
    if (etapaAnterior && novos[etapaAnterior] && !novos[etapaAnterior].fim) {
        novos[etapaAnterior] = { ...novos[etapaAnterior], fim: agora };
    }
    if (etapaNova && !novos[etapaNova]) {
        novos[etapaNova] = { inicio: agora, fim: null };
    }
    return novos;
}

export function duracaoEtapa(tempos, chave, agora) {
    const etapa = tempos && tempos[chave];
    if (!etapa || !etapa.inicio) return null;
    return Math.max(0, (etapa.fim || agora) - etapa.inicio);
}

export function etapaEmAndamento(tempos, chave) {
    const etapa = tempos && tempos[chave];
    return !!etapa && !!etapa.inicio && !etapa.fim;
}

export function formatarDuracao(ms) {
    if (ms == null) return "";
    const total = Math.floor(ms / 1000);
    const horas = Math.floor(total / 3600);
    const minutos = Math.floor((total % 3600) / 60);
    const segundos = total % 60;
    const dois = (n) => String(n).padStart(2, "0");
    if (horas > 0) return `${horas}h ${dois(minutos)}m ${dois(segundos)}s`;
    if (minutos > 0) return `${minutos}m ${dois(segundos)}s`;
    return `${segundos}s`;
}

// Atualiza "agora" a cada segundo para os cronômetros das etapas em andamento.
export const RelogioMixin = {
    data() {
        return { agora: Date.now() };
    },
    mounted() {
        this.relogioHandle = setInterval(() => {
            this.agora = Date.now();
        }, 1000);
    },
    beforeDestroy() {
        clearInterval(this.relogioHandle);
    },
};
